// extracted by mini-css-extract-plugin
export default {"companyInfo":"style_companyInfo__nZWms","Avatar":"style_Avatar__55MO0","companyName":"style_companyName__igfWt"};